import { ca } from '@cian/analytics';
import { getAnalyticsOfferStatus } from '../../../../utils';

export const trackServicesVisible = (isNewOffer: boolean, serviceIds: string[]) => {
  ca('eventSite', {
    name: 'oldevent',
    category: getAnalyticsOfferStatus(isNewOffer),
    action: 'publish_terms_block_show',
    label: serviceIds.join('/'),
  });
};

export const trackScrollSlider = (isNewOffer: boolean, label: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: getAnalyticsOfferStatus(isNewOffer),
    action: 'publish_terms_block_scroll',
    label,
  });
};
